import { Plane } from "lucide-react";
import { MARQUEE } from "@/data";
import { useLang } from "@/i18n";

export function Marquee() {
  const { lang } = useLang();
  const items = MARQUEE[lang];
  const track = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" data-always-dark className="relative overflow-hidden border-b border-blue-500/15 bg-[#081020] py-4" dir="ltr">
      <div className="animate-marquee flex w-max items-center gap-10">
        {track.map((item, i) => (
          <div key={i} className="flex items-center gap-10">
            <span className={`whitespace-nowrap text-sm font-medium text-slate-300 ${lang === "ar" ? "" : "font-mono-tag tracking-wide"}`} dir={lang === "ar" ? "rtl" : "ltr"}>
              {item}
            </span>
            <Plane size={13} className="text-blue-500/70 -rotate-45 shrink-0" />
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#081020] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#081020] to-transparent" />
    </div>
  );
}
